import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

import { useIsMobile } from 'utils/useIsMobile'

export const ChartContentLoader = () => {
  const theme = useTheme()
  const xAxisY = 510
  const chartWidth = 1100
  const chartStartX = 60
  const pointCount = 16
  const step = chartWidth / (pointCount - 1)

  const points = Array.from({ length: pointCount }, (_, i) => {
    const x = chartStartX + i * step
    const y = 260 + Math.sin(i * 0.8) * 30 + Math.random() * 10
    return { x, y }
  })

  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y.toFixed(0)}`).join(' ')
  const areaPath = `${linePath} L ${points[points.length - 1].x} ${xAxisY} L ${points[0].x} ${xAxisY} Z`

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={560}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      viewBox="0 0 1150 560"
      style={{ width: '100%', height: '560px' }}
    >
      <rect x="0" y="20" rx="4" ry="4" width="140" height="20" />
      <rect x="860" y="20" rx="4" ry="4" width="50" height="20" />
      <rect x="940" y="20" rx="4" ry="4" width="50" height="20" />
      <rect x="1020" y="20" rx="4" ry="4" width="50" height="20" />
      <rect x="1100" y="20" rx="4" ry="4" width="50" height="20" />

      {points.map((point, i) => (
        <rect key={`tick-${i}`} x={point.x - 14} y={xAxisY + 10} rx="3" ry="3" width={28} height={10} />
      ))}

      <path d={areaPath} fill={theme.colors.contentLoader.foregroundColor} opacity="0.3" />
      <path d={linePath} stroke={theme.colors.contentLoader.foregroundColor} strokeWidth="2" fill="none" />
      <rect x="60" y={xAxisY} width="1100" height="1.5" fill="#374151" />
    </ContentLoader>
  )
}

export const ChartContentLoaderMobile = () => {
  const theme = useTheme()
  const chartWidth = 320
  const chartHeight = 360
  const chartStartX = 30
  const chartEndX = chartWidth - chartStartX
  const xAxisY = chartHeight - 50
  const pointCount = 8
  const step = (chartEndX - chartStartX) / (pointCount - 1)

  const points = Array.from({ length: pointCount }, (_, i) => {
    const x = chartStartX + i * step
    const y = 160 + Math.sin(i * 0.7) * 20 + Math.random() * 8
    return { x, y }
  })

  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y.toFixed(0)}`).join(' ')
  const areaPath = `${linePath} L ${points[points.length - 1].x} ${xAxisY} L ${points[0].x} ${xAxisY} Z`

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={chartHeight}
      viewBox={`0 0 ${chartWidth} ${chartHeight}`}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      style={{ width: '100%', height: `${chartHeight}px` }}
    >
      <rect x={chartWidth / 2 - 60} y="16" rx="4" ry="4" width="50" height="20" />
      <rect x={chartWidth / 2 + 10} y="16" rx="4" ry="4" width="50" height="20" />

      {Array.from({ length: 4 }).map((_, i) => (
        <rect key={`btn-${i}`} x={chartWidth / 2 - 90 + i * 50} y="48" rx="4" ry="4" width="40" height="18" />
      ))}

      <rect x={chartWidth / 2 - 40} y="78" rx="2" ry="2" width="80" height="10" />

      {points.map((point, i) => (
        <rect key={`tick-${i}`} x={point.x - 10} y={xAxisY + 6} rx="2" ry="2" width={20} height={8} />
      ))}

      <path d={areaPath} fill={theme.colors.contentLoader.foregroundColor} opacity="0.3" />
      <path d={linePath} stroke={theme.colors.contentLoader.foregroundColor} strokeWidth="1.5" fill="none" />
    </ContentLoader>
  )
}

export const ChartContentLoaderResponsive = () => {
  const isMobile = useIsMobile()
  return isMobile ? <ChartContentLoaderMobile /> : <ChartContentLoader />
}
